module.exports = "../fonts/icomoon.ttf";